<template>
    <div v-if="loaded">
        <!-- Page heading -->
        <h1 class="page-title">
            My Profile
        </h1>

        <form @submit.prevent="processForm">
            <!-- Subheading -->
            <h2 class="mb-5">
                Personal Details
            </h2>

            <b-row>
                <b-col
                    cols="12"
                    lg="8"
                >
                    <b-row>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <!-- Field: Title -->
                            <div class="field-wrap">
                                <h4 class="mb-3 color-mid-grey text-bold">
                                    Title
                                </h4>
                                <label
                                    for="field-title"
                                    class="sr-only"
                                >
                                    Title
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="field-title"
                                        v-model="profile.prefix"
                                        v-validate="{
                                            required: true
                                        }"
                                        :class="{ 'has-error': showErrors && errors.has('field-title') }"
                                        name="field-title"
                                    >
                                        <option
                                            disabled
                                            selected
                                            hidden
                                            value=""
                                        >
                                            Select
                                        </option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Miss</option>
                                        <option>Ms.</option>
                                        <option>Dr.</option>
                                    </select>
                                </div>
                                <div
                                    v-if="showErrors && errors.has('field-title')"
                                    class="py-3"
                                >
                                    <div class="d-inline-block alert-error p-3 rounded-corners">
                                        Please select an option
                                    </div>
                                </div>
                            </div>
                            <!-- END Field: Title -->
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <!-- Field: Forename -->
                            <div class="field-wrap">
                                <h4 class="mb-3 color-mid-grey text-bold">
                                    Forename
                                </h4>
                                <label
                                    for="field-forename"
                                    class="sr-only"
                                >
                                    Forename
                                </label>
                                <div class="field-wrap__input">
                                    <input
                                        id="field-forename"
                                        v-model="profile.first_name"
                                        v-validate="{
                                            required: true,
                                            regex: /^[A-Za-z0-9\-]+$/
                                        }"
                                        :class="{ 'has-error': showErrors && errors.has('field-forename') }"
                                        type="text"
                                        name="field-forename"
                                        placeholder="Forename"
                                    >
                                </div>
                                <div
                                    v-if="showErrors && errors.has('field-forename')"
                                    class="py-3"
                                >
                                    <div class="d-inline-block alert-error p-3 rounded-corners">
                                        Please enter your forename
                                    </div>
                                </div>
                            </div>
                            <!-- END Field: Forename -->
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <!-- Field: Surname -->
                            <div class="field-wrap">
                                <h4 class="mb-3 color-mid-grey text-bold">
                                    Surname
                                </h4>
                                <label
                                    for="field-surname"
                                    class="sr-only"
                                >
                                    Surname
                                </label>
                                <div class="field-wrap__input">
                                    <input
                                        id="field-surname"
                                        v-model="profile.last_name"
                                        v-validate="{
                                            required: true,
                                            regex: /^[A-Za-z0-9\-]+$/
                                        }"
                                        :class="{ 'has-error': showErrors && errors.has('field-surname') }"
                                        type="text"
                                        name="field-surname"
                                        placeholder="Surname"
                                    >
                                </div>
                                <div
                                    v-if="showErrors && errors.has('field-surname')"
                                    class="py-3"
                                >
                                    <div class="d-inline-block alert-error p-3 rounded-corners">
                                        Please enter your surname
                                    </div>
                                </div>
                            </div>
                            <!-- END Field: Surname -->
                        </b-col>
                    </b-row>

                    <!-- Field: Email -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Email Address
                        </h4>
                        <label
                            for="field-email"
                            class="sr-only"
                        >
                            Email Address
                        </label>
                        <div class="field-wrap__input">
                            <input
                                id="field-email"
                                v-model="profile.email"
                                v-validate="{
                                    required: true,
                                    email: true
                                }"
                                :class="{ 'has-error': showErrors && errors.has('field-email') }"
                                type="text"
                                name="field-email"
                                placeholder="Email Address"
                            >
                        </div>
                        <div
                            v-if="showErrors && errors.has('field-email')"
                            class="py-3"
                        >
                            <div class="d-inline-block alert-error p-3 rounded-corners">
                                Please enter a valid email address
                            </div>
                        </div>
                    </div>
                    <!-- END Field: Email -->

                    <b-row>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <!-- Field: Home telephone -->
                            <div class="field-wrap">
                                <h4 class="mb-3 color-mid-grey text-bold">
                                    Home Telephone
                                </h4>
                                <label
                                    for="field-hometel"
                                    class="sr-only"
                                >
                                    Home Telephone
                                </label>
                                <div class="field-wrap__input">
                                    <input
                                        id="field-hometel"
                                        v-model="profile.telephone"
                                        v-validate="{
                                            required: true,
                                            regex: /^\+?[0-9 ]+$/
                                        }"
                                        :class="{ 'has-error': showErrors && errors.has('field-hometel') }"
                                        type="text"
                                        name="field-hometel"
                                        placeholder="Home Telephone"
                                    >
                                </div>
                                <div
                                    v-if="showErrors && errors.has('field-hometel')"
                                    class="py-3"
                                >
                                    <div class="d-inline-block alert-error p-3 rounded-corners">
                                        Please enter a valid home telephone number
                                    </div>
                                </div>
                            </div>
                            <!-- END Field: Home telephone -->
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <!-- Field: Mobile telephone -->
                            <div class="field-wrap">
                                <h4 class="mb-3 color-mid-grey text-bold">
                                    Mobile Telephone
                                </h4>
                                <label
                                    for="field-mobiletel"
                                    class="sr-only"
                                >
                                    Mobile Telephone
                                </label>
                                <div class="field-wrap__input">
                                    <input
                                        id="field-mobiletel"
                                        v-model="profile.mobile_telephone"
                                        v-validate="{
                                            required: true,
                                            regex: /^\+?[0-9 ]+$/
                                        }"
                                        :class="{ 'has-error': showErrors && errors.has('field-mobiletel') }"
                                        type="text"
                                        name="field-mobiletel"
                                        placeholder="Mobile Telephone"
                                    >
                                </div>
                                <div
                                    v-if="showErrors && errors.has('field-mobiletel')"
                                    class="py-3"
                                >
                                    <div class="d-inline-block alert-error p-3 rounded-corners">
                                        Please enter a valid mobile telephone number
                                    </div>
                                </div>
                            </div>
                            <!-- END Field: Mobile telephone -->
                        </b-col>
                    </b-row>
                </b-col>
                <b-col
                    cols="12"
                    lg="4"
                >
                    <div class="card d-flex alerts-card">
                        <div class="card__body d-flex flex-column align-items-start">
                            <!-- Details -->
                            <div
                                v-if="user.created_at"
                                class="table-flex mb-5 w-100"
                            >
                                <div>
                                    <div>Created</div>
                                    <div class="text-lg-right">
                                        {{ user.created_at | moment('L') }}
                                    </div>
                                </div>
                            </div>
                            <!-- END Details -->
                            <!-- END Details -->

                            <!-- Alerts -->
                            <div
                                v-if="notifications.length"
                                class="bg-lightest-grey p-4 p-lg-5 rounded-corners w-100"
                            >
                                <ul class="icon-list icon-list--alert list-unstyled mb-0">
                                    <li
                                        v-for="notification in notifications"
                                        :key="notification.id"
                                        class="d-flex justify-content-start"
                                    >
                                        <SVGSprite
                                            name="bell"
                                            class="icon-list__svg"
                                        />
                                        <span class="p-sm color-primary text-bold">{{ notification.content }}</span>
                                    </li>
                                </ul>
                            </div>
                            <!-- END Alerts -->

                            <!-- Profile actions -->
                            <button
                                type="button"
                                class="color-mid-grey text-underline mt-5 px-0 align-self-start"
                                @click="$refs.modalDeleteAccount.show()"
                            >
                                Delete Account
                            </button>

                            <b-modal
                                ref="modalDeleteAccount"
                                title="Delete Account"
                                @ok="deleteAccount"
                            >
                                <p>Are you sure you want to delete your account?</p>
                            </b-modal>
                            <!-- END Profile actions -->
                        </div>
                    </div>
                </b-col>
            </b-row>

            <hr>

            <!-- Subheading -->
            <h2 class="mb-5">
                AML Check
            </h2>

            <AMLCheck />

            <hr>

            <!-- Sub heading -->
            <h2 class="mb-5">
                Personal Address
            </h2>

            <b-row
                v-if="addresses || profile.primary_address_id !== 'new'"
            >
                <b-col
                    cols="12"
                    lg="6"
                >
                    <div class="field-wrap__input field-wrap__input--select mb-4">
                        <select
                            id="field-selectaddress"
                            v-model="profile.primary_address_id"
                            v-validate="{ required: true }"
                            :class="{ 'has-error': showErrors && errors.has('field-selectaddress') }"
                            name="field-selectaddress"
                        >
                            <option
                                disabled
                                selected
                                hidden
                                value=""
                            >
                                Select an address
                            </option>
                            <option
                                v-for="address in addresses"
                                :key="address.id"
                                :value="address.id"
                            >
                                {{ address.label }}
                            </option>
                            <option value="new">
                                Add a new address
                            </option>
                        </select>
                    </div>
                    <div
                        v-if="showErrors && errors.has('field-selectaddress')"
                        class="py-3"
                    >
                        <div class="d-inline-block alert-error p-3 rounded-corners">
                            Please select an address or enter a new one
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row
                v-if="profile.primary_address_id === 'new'"
                class="pt-3"
            >
                <b-col
                    cols="12"
                    lg="6"
                    class="mb-5"
                >
                    <!-- Field: Search address -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Address Lookup
                        </h4>
                        <label
                            for="field-search"
                            class="sr-only"
                        >
                            Postcode
                        </label>
                        <div class="field-wrap__input field-wrap__input--prepend field-wrap__input--prepend-fill">
                            <input
                                id="field-search"
                                v-model="postcodeSearch"
                                type="search"
                                name="field-search"
                                placeholder="Postcode or Location e.g. London"
                            >
                            <div class="field-wrap__input-icon">
                                <SVGSprite
                                    name="search"
                                    class="form-icon"
                                />
                            </div>
                        </div>
                    </div>
                    <button
                        class="btn btn--secondary mb-5"
                        @click.prevent="searchAddress()"
                    >
                        Search Address
                    </button>
                    <!-- END Field: Search address -->

                    <!-- Field: Address Lines -->
                    <div class="field-wrap">
                        <!-- Field: Address Line 1 -->
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Address
                        </h4>
                        <label
                            for="field-address-1"
                            class="sr-only"
                        >
                            Address Line 1
                        </label>
                        <div class="field-wrap__input mb-4">
                            <input
                                id="field-address-1"
                                v-model="profile.address"
                                v-validate="{ required: true }"
                                :class="{ 'has-error': showErrors && errors.has('field-address-1') }"
                                type="text"
                                name="field-address-1"
                                placeholder="Address Line 1"
                            >
                        </div>
                        <div
                            v-if="showErrors && errors.has('field-address-1')"
                            class="py-3"
                        >
                            <div class="d-inline-block alert-error p-3 rounded-corners">
                                Please enter your address
                            </div>
                        </div>
                        <!-- END Field: Address Line 1 -->

                        <!-- Field: Address Line 2 -->
                        <label
                            for="field-address-2"
                            class="sr-only"
                        >
                            Address Line 2
                        </label>
                        <div class="field-wrap__input mb-4">
                            <input
                                id="field-address-2"
                                v-model="profile.address2"
                                :class="{ 'has-error': showErrors && errors.has('field-address-2') }"
                                type="text"
                                name="field-address-2"
                                placeholder="Address Line 2"
                            >
                        </div>
                        <!-- END Field: Address Line 2 -->

                        <!-- Field: Postcode -->
                        <label
                            for="field-postcode"
                            class="sr-only"
                        >
                            Postcode
                        </label>
                        <div class="field-wrap__input mb-4">
                            <input
                                id="field-postcode"
                                v-model="profile.postcode"
                                v-validate="{ required: true }"
                                :class="{ 'has-error': showErrors && errors.has('field-postcode') }"
                                type="text"
                                name="field-postcode"
                                placeholder="Postcode"
                            >
                        </div>
                        <div
                            v-if="showErrors && errors.has('field-postcode')"
                            class="py-3"
                        >
                            <div class="d-inline-block alert-error p-3 rounded-corners">
                                Please enter your postcode
                            </div>
                        </div>
                        <!-- END Field: Postcode -->
                    </div>
                </b-col>
                <b-col
                    cols="12"
                    lg="6"
                    class="mb-5"
                >
                    <!-- Field: Town / City -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Town / City
                        </h4>
                        <label
                            for="field-town-city"
                            class="sr-only"
                        >
                            Town / City
                        </label>
                        <div class="field-wrap__input mb-4">
                            <input
                                id="field-town-city"
                                v-model="profile.town"
                                v-validate="{ required: true }"
                                :class="{ 'has-error': showErrors && errors.has('field-town-city') }"
                                type="text"
                                name="field-town-city"
                                placeholder="Town / City"
                            >
                        </div>
                        <div
                            v-if="showErrors && errors.has('field-town-city')"
                            class="py-3"
                        >
                            <div class="d-inline-block alert-error p-3 rounded-corners">
                                Please enter your town or city
                            </div>
                        </div>
                    </div>
                    <!-- END Field: Town / City -->

                    <!-- Field: County -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            County
                        </h4>
                        <label
                            for="field-county"
                            class="sr-only"
                        >
                            County
                        </label>
                        <div class="field-wrap__input mb-4">
                            <input
                                id="field-county"
                                v-model="profile.county"
                                type="text"
                                name="field-county"
                                placeholder="County"
                            >
                        </div>
                    </div>
                    <!-- END Field: County -->

                    <!-- Field: Country -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Country
                        </h4>
                        <label
                            for="field-country"
                            class="sr-only"
                        >
                            Country
                        </label>
                        <div class="field-wrap__input mb-4">
                            <input
                                id="field-country"
                                v-model="profile.country"
                                v-validate="{ required: true }"
                                :class="{ 'has-error': showErrors && errors.has('field-country') }"
                                type="text"
                                name="field-country"
                                placeholder="Country"
                            >
                        </div>
                        <div
                            v-if="showErrors && errors.has('field-country')"
                            class="py-3"
                        >
                            <div class="d-inline-block alert-error p-3 rounded-corners">
                                Please select your country
                            </div>
                        </div>
                    </div>
                    <!-- END Field: Country -->
                </b-col>
            </b-row>

            <!-- Separator -->
            <hr>

            <!-- Subheading -->
            <h2 class="mb-5">
                Change Password
            </h2>

            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <!-- Field: Current password -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Current Password
                        </h4>
                        <label
                            for="field-currentpass"
                            class="sr-only"
                        >
                            Current Password
                        </label>
                        <div class="field-wrap__input">
                            <input
                                id="field-currentpass"
                                v-model="profile.old_password"
                                type="password"
                                name="field-currentpass"
                            >
                        </div>
                    </div>
                    <!-- END Field: Current password -->
                </b-col>
            </b-row>

            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <!-- Field: New password -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            New Password
                        </h4>
                        <label
                            for="field-password"
                            class="sr-only"
                        >
                            New Password
                        </label>
                        <div class="field-wrap__input">
                            <password
                                id="field-password"
                                v-model="profile.password"
                                :required="false"
                                :toggle="true"
                                :badge="false"
                                name="field-password"
                            />
                        </div>
                    </div>
                    <!-- END Field: New password -->
                </b-col>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <!-- Field: Confirm password -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Confirm Password
                        </h4>
                        <label
                            for="field-password-confirm"
                            class="sr-only"
                        >
                            Confirm Password
                        </label>
                        <div class="field-wrap__input">
                            <input
                                id="field-password-confirm"
                                v-model="profile.password_confirmation"
                                v-validate="{ confirmed: profile.password }"
                                :class="{ 'has-error': errors.has('field-password-confirm') }"
                                type="password"
                                name="field-password-confirm"
                            >
                        </div>
                        <div
                            v-if="showErrors && errors.has('field-password-confirm')"
                            class="py-3"
                        >
                            <div class="d-inline-block alert-error p-3 rounded-corners">
                                The entered password confirmation does not match
                            </div>
                        </div>
                    </div>
                    <!-- END Field: Confirm password -->
                </b-col>
            </b-row>

            <!-- Separator -->
            <hr>

            <!-- Subheading -->
            <h2 class="mb-5">
                Key User Questions
            </h2>

            <b-row>
                <b-col
                    cols="12"
                    lg="8"
                    class="mb-5"
                >
                    <p>Please tick the below boxes so that we can offer you the best possible service and assistance during your my online estate agent experience by tailoring our advice to your needs.</p>
                </b-col>
            </b-row>

            <!-- Field: Essentials -->
            <div class="field-wrap">
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-essentials-1"
                        v-model="profile.house_to_sell"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-essentials"
                    >
                    <label for="field-essentials-1"><span class="check-element" />Do you have a house to sell?</label>
                </div>
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-essentials-2"
                        v-model="profile.applied_for_mortgage"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-essentials"
                    >
                    <label for="field-essentials-2"><span class="check-element" />Have you applied for a mortgage?</label>
                </div>
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-essentials-3"
                        v-model="profile.looking_to_buy"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-essentials"
                    >
                    <label for="field-essentials-3"><span class="check-element" />Are you looking to buy a new house?</label>
                </div>
            </div>
            <!-- END Field: Essentials -->

            <!-- Separator -->
            <hr>

            <!-- Subheading -->
            <h2 class="mb-5">
                Marketing Preferences
            </h2>

            <b-row>
                <b-col
                    cols="12"
                    lg="8"
                    class="mb-5"
                >
                    <p>To receive monthly property and news updates, as well as future marketing information from my online estate agent, please tick the below boxes on the type and method of communication you would like to receive.</p>
                </b-col>
            </b-row>

            <!-- Subheading -->
            <h3 class="color-mid-grey mb-4 h4 text-bold">
                Types of Communication
            </h3>

            <!-- Marketing preferences -->
            <div class="field-wrap">
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-marketing-type-1"
                        v-model="profile.notify_types.marketing_communication"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-marketing-type"
                    >
                    <label for="field-marketing-type-1"><span class="check-element" />Do you wish to receive Marketing Communication?</label>
                </div>
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-marketing-type-2"
                        v-model="profile.notify_types.monthly_news_updates"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-marketing-type"
                    >
                    <label for="field-marketing-type-2"><span class="check-element" />Do you wish to receive Monthly News Updates?</label>
                </div>
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-marketing-type-3"
                        v-model="profile.notify_types.property_updates"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-marketing-type"
                    >
                    <label for="field-marketing-type-3"><span class="check-element" />Do you wish to receive Property Updates?</label>
                </div>
            </div>
            <!-- END Marketing preferences -->

            <!-- Subheading -->
            <h3 class="color-mid-grey mb-4 h4 text-bold">
                Methods of Communication
            </h3>

            <!-- Marketing methods -->
            <div class="field-wrap">
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-marketing-method-1"
                        v-model="profile.notify_phone"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-marketing-method"
                    >
                    <label for="field-marketing-method-1"><span class="check-element" />Do you wish to receive communication via telephone?</label>
                </div>
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-marketing-method-2"
                        v-model="profile.notify_sms"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-marketing-method"
                    >
                    <label for="field-marketing-method-2"><span class="check-element" />Do you wish to receive communication via SMS?</label>
                </div>
                <div class="field-wrap__input field-wrap__input--checkbox mb-3">
                    <input
                        id="field-marketing-method-3"
                        v-model="profile.notify_email"
                        :true-value="true"
                        :false-value="false"
                        type="checkbox"
                        name="field-marketing-method"
                    >
                    <label for="field-marketing-method-3"><span class="check-element" />Do you wish to receive communication via Email?</label>
                </div>
            </div>
            <!-- END Marketing methods -->

            <hr>

            <div v-if="viewings">
                <!-- Subheading -->
                <h2 class="mb-3">
                    Viewings
                </h2>

                <p class="mb-5">
                    See your viewing history here
                </p>

                <div class="card">
                    <!-- Messages Heading -->
                    <div class="d-flex align-items-center justify-content-between px-4 py-5">
                        <h3>History</h3>
                        <div class="d-flex align-items-center">
                            <span class="mr-4">{{ viewings.from }}-{{ viewings.to }} of {{ viewings.total }}</span>
                            <span class="d-flex align-items-center">
                                <button
                                    :disabled="!viewings.show_prev"
                                    type="button"
                                    class="btn--inherit"
                                    @click="getOrders(viewings.current_page - 1)"
                                >
                                    <SVGSprite
                                        :class="{ 'arrow-icon-disabled': !viewings.show_prev }"
                                        name="arrow-square-left"
                                        class="arrow-icon"
                                    />
                                </button>
                                <button
                                    :disabled="!viewings.show_next"
                                    type="button"
                                    class="btn--inherit"
                                    @click="getOrders(viewings.current_page + 1)"
                                >
                                    <SVGSprite
                                        :class="{ 'arrow-icon-disabled': !viewings.show_next }"
                                        name="arrow-square-right"
                                        class="arrow-icon"
                                    />
                                </button>
                            </span>
                        </div>
                    </div>
                    <!-- END Messages Heading -->

                    <!-- Message listing -->
                    <div
                        id="table-viewings"
                        class="table-flex table-flex--plain table-flex--cell-1-sm table-flex--cell-2-md table-flex--cell-4-md table-flex--cell-5-md"
                    >
                        <div class="table-flex--header">
                            <div>ID</div>
                            <div>Date and Time</div>
                            <div>Property</div>
                            <div>Status</div>
                            <div />
                        </div>
                        <div
                            v-for="viewing in viewings.data"
                            :key="viewing.id"
                        >
                            <div>#{{ viewing.id }}</div>
                            <div>{{ viewing.start_at | moment('L') }}</div>
                            <div>{{ viewing.property_name }}</div>
                            <div>{{ viewing.status.display_name }}</div>
                            <div>
                                <button
                                    type="button"
                                    class="btn btn--outline btn--nomin btn--sm"
                                    @click="showViewing(viewing.id)"
                                >
                                    View
                                </button>
                            </div>
                        </div>
                    </div>

                    <b-modal
                        ref="modalViewing"
                        size="lg"
                        title="Viewing Details"
                        hide-footer
                    >
                        <table
                            v-if="visibleViewing"
                            class="table mb-5"
                        >
                            <tbody>
                                <tr>
                                    <th scope="row">
                                        ID
                                    </th>
                                    <td>{{ visibleViewing.id }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Date and Time
                                    </th>
                                    <td>{{ visibleViewing.created_at | moment('L') }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Property
                                    </th>
                                    <td>
                                        <router-link
                                            :to="{
                                                name: 'view-property',
                                                params: {
                                                    id: visibleViewing.id
                                                }
                                            }"
                                        >
                                            {{ visibleViewing.property_name }}
                                        </router-link>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Status
                                    </th>
                                    <td>{{ visibleViewing.status.display_name }}</td>
                                </tr>
                                <tr v-if="visibleViewing.feedback">
                                    <th scope="row">
                                        Feedback
                                    </th>
                                    <td>{{ visibleViewing.feedback }}</td>
                                </tr>
                                <tr v-if="visibleViewing.feedback_at">
                                    <th scope="row">
                                        Feedback added at
                                    </th>
                                    <td>{{ visibleViewing.feedback_at | moment('L HH:mm') }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="feedbackAllowed && !visibleViewing.feedback">
                            <p>
                                Please provide feedback on your property viewing experience, such as how well it matched
                                your criteria and whether you are interested in a second viewing or considering making
                                an offer.
                            </p>
                            <form @submit.prevent="handleSubmitFeedback">
                                <div class="field-wrap mb-0">
                                    <label
                                        for="field-feedback"
                                        class="sr-only"
                                    >
                                        Feedback
                                    </label>
                                    <div class="field-wrap__input field-wrap__input--border-dark mb-3">
                                        <textarea
                                            id="field-feedback"
                                            v-model="viewingFeedback"
                                            v-validate="{ required: true }"
                                            :class="{ 'has-error': showErrors && errors.has('field-feedback') }"
                                            type="textarea"
                                            name="field-feedback"
                                            placeholder="Enter your feedback here..."
                                            rows="10"
                                        />
                                    </div>
                                    <div
                                        v-if="showErrors && errors.has('field-feedback')"
                                        class="py-3"
                                    >
                                        <div class="d-inline-block alert-error p-3 rounded-corners">
                                            Please enter your feedback
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        class="btn btn--secondary"
                                    >
                                        Send Feedback
                                    </button>
                                </div>
                            </form>
                        </div>
                    </b-modal>
                    <!-- END Message listing -->
                </div>

                <hr>
            </div>

            <div v-if="user.orders && user.orders.data && user.orders.data.length">
                <!-- Subheading -->
                <h2 class="mb-3">
                    Order History
                </h2>

                <p class="mb-5">
                    View your order history here
                </p>

                <div class="card">
                    <!-- Messages Heading -->
                    <div class="d-flex align-items-center justify-content-between px-4 py-5">
                        <h3>History</h3>
                        <div class="d-flex align-items-center">
                            <span class="mr-4">{{ user.orders.from }}-{{ user.orders.to }} of {{ user.orders.total }}</span>
                            <span class="d-flex align-items-center">
                                <button
                                    :disabled="!orderActiveButtons.prev"
                                    type="button"
                                    class="btn--inherit"
                                    @click="getOrders(user.orders.current_page - 1)"
                                >
                                    <SVGSprite
                                        :class="{ 'arrow-icon-disabled': !orderActiveButtons.prev }"
                                        name="arrow-square-left"
                                        class="arrow-icon"
                                    />
                                </button>
                                <button
                                    :disabled="!orderActiveButtons.next"
                                    type="button"
                                    class="btn--inherit"
                                    @click="getOrders(user.orders.current_page + 1)"
                                >
                                    <SVGSprite
                                        :class="{ 'arrow-icon-disabled': !orderActiveButtons.next }"
                                        name="arrow-square-right"
                                        class="arrow-icon"
                                    />
                                </button>
                            </span>
                        </div>
                    </div>
                    <!-- END Messages Heading -->

                    <!-- Message listing -->
                    <div
                        id="table-messages"
                        class="table-flex table-flex--plain table-flex--cell-1-sm table-flex--cell-2-md table-flex--cell-4-md table-flex--cell-5-md"
                    >
                        <div class="table-flex--header">
                            <div>ID</div>
                            <div>Date</div>
                            <div>Property</div>
                            <div>Total</div>
                            <div />
                        </div>
                        <div
                            v-for="order in user.orders.data"
                            :key="order.id"
                        >
                            <div>#{{ order.id }}</div>
                            <div>{{ order.created_at | moment('L') }}</div>
                            <div>{{ order.property.name }}</div>
                            <div>{{ order.total | price }}</div>
                            <div>
                                <button
                                    type="button"
                                    class="btn btn--outline btn--nomin btn--sm"
                                    @click="showOrder(order.id)"
                                >
                                    View
                                </button>
                            </div>
                        </div>
                    </div>

                    <b-modal
                        ref="modalOrder"
                        :title="'Order #' + (visibleOrder && visibleOrder.id)"
                        hide-footer
                    >
                        <table
                            v-if="visibleOrder"
                            class="table mb-5"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col">
                                        Name
                                    </th>
                                    <th scope="col">
                                        Quantity
                                    </th>
                                    <th scope="col">
                                        Price
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in visibleOrder.items"
                                    :key="item.id"
                                >
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.quantity }}</td>
                                    <td>{{ item.price | price }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table
                            v-if="visibleOrder"
                            class="table"
                        >
                            <tbody>
                                <tr>
                                    <th scope="row">
                                        Date
                                    </th>
                                    <td>{{ visibleOrder.created_at | moment('L') }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Property
                                    </th>
                                    <td>{{ visibleOrder.property.name }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Subtotal
                                    </th>
                                    <td>{{ visibleOrder.subtotal | price }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        VAT @ {{ visibleOrder.tax_rate_display }}%
                                    </th>
                                    <td>{{ visibleOrder.tax | price }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        Total
                                    </th>
                                    <td>{{ visibleOrder.total | price }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-modal>
                    <!-- END Message listing -->
                </div>

                <!-- Separator -->
                <hr>
            </div>

            <div class="sticky-save bg-white rounded-corners p-3">
                <button
                    class="sticky-save__btn"
                    @submit.prevent="processForm"
                >
                    <SVGSprite
                        name="save"
                        class="sticky-save__icon"
                    />
                    <span class="ml-3">Save</span>
                </button>
            </div>
        </form>

        <!-- Property lookup modal -->
        <PostcodeLookup
            ref="postcodeLookup"
            @propertySelected="prefillAddress"
            @pageLoaderRemove="hidePageLoader"
        />
        <!-- END Property lookup modal -->

        <b-modal
            ref="modalProfileSaved"
            title="Profile Saved"
            header-bg-variant="secondary"
            ok-title="Go to My Properties"
            ok-variant="-secondary"
            cancel-title="Close"
            cancel-variant="-primary"
            @ok="$router.push({
                name: 'my-properties'
            })"
        >
            <p>
                Your profile has been successfully updated.
            </p>
        </b-modal>
        <!-- END Profile actions -->

        <!-- Loader -->
        <transition name="fade">
            <div
                v-if="pageLoader"
                class="page-loader"
            >
                <div>
                    <SVGSprite
                        name="loader"
                        class="loader-icon spin-animation"
                    />
                </div>
            </div>
        </transition>
        <!-- END Loader -->
    </div>
</template>

<script>
import { cloneDeep, pick } from 'lodash-es';
import { mapState, mapActions, mapGetters } from 'vuex';
import Password from 'vue-password-strength-meter';
import AMLCheck from '../components/AMLCheck';
import PostcodeLookup from '../components/PostcodeLookup';

export default {
    name: 'MyProfile',
    components: {
        AMLCheck,
        Password,
        PostcodeLookup
    },
    data() {
        return {
            proxyUrl: 'https://cors-anywhere.herokuapp.com/',
            postcodeSearch: '',
            pageLoader: false,
            loaded: false,
            showErrors: false,
            profile: {
                prefix: '',
                first_name: '',
                last_name: '',
                email: '',
                telephone: '',
                mobile_telephone: '',
                address: '',
                address2: '',
                town: '',
                county: '',
                postcode: '',
                country: '',
                old_password: '',
                password: '',
                password_confirmation: '',
                property_to_sell: false,
                has_mortgage: true,
                looking_to_buy: false,
                notify_email: false,
                notify_sms: false,
                notify_phone: false,
                notify_types: {
                    marketing_communication: false,
                    monthly_news_updates: false,
                    property_updates: false
                },
                primary_address_id: ''
            },
            visibleOrder: null,
            visibleViewing: null,
            viewingFeedback: ''
        };
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapGetters('user', ['addresses']),
        orderActiveButtons() {
            return {
                prev: this.user.orders.current_page > 1,
                next: this.user.orders.current_page > 0 && this.user.orders.current_page < this.user.orders.last_page
            };
        },
        notifications() {
            return (this.user.notifications && this.user.notifications.filter(notification => notification.category === 'account').splice(0, 3)) || [];
        },
        viewings() {
            try {
                return this.user.viewings.total > 0 ? {
                    ...this.user.viewings,
                    show_prev: this.user.viewings.current_page > 1,
                    show_next: this.user.viewings.current_page > 0 && this.user.viewings.current_page < this.user.viewings.last_page
                } : false;
            }
            catch (e) {
                return false;
            }
        },
        feedbackAllowed() {
            try {
                return this.visibleViewing && this.$moment.duration(this.$moment().diff(this.visibleViewing.start_at)).as('minutes') >= 20;
            }
            catch (e) {
                return false;
            }
        }
    },
    mounted() {
        this.checkAuthentication()
            .then(() => {
                this.populateForm();

                if (this.$route.params.sectionName === 'viewing' && this.$route.params.sectionId) {
                    const viewing = this.viewings.data.find(viewingItem => viewingItem.id === parseInt(this.$route.params.sectionId, 10));

                    if (viewing) {
                        this.visibleViewing = viewing;

                        this.$nextTick(() => {
                            this.$refs.modalViewing.show();
                        });
                    }
                }

                this.loaded = true;
            });
    },
    methods: {
        ...mapActions('user', ['checkAuthentication', 'updateProfile', 'deleteAccount', 'getOrders', 'refreshUser']),
        ...mapActions('properties', ['updateViewing']),
        populateForm() {
            Object.assign(this.profile, cloneDeep(pick(this.user, [
                'prefix',
                'first_name',
                'last_name',
                'email',
                'telephone',
                'mobile_telephone',
                'address',
                'address2',
                'town',
                'county',
                'country',
                'house_to_sell',
                'applied_for_mortgage',
                'looking_to_buy',
                'notify_email',
                'notify_sms',
                'notify_phone'
            ])));

            Object.assign(this.profile.notify_types, cloneDeep(this.user.notify_types));

            if (this.addresses.length) {
                this.profile.primary_address_id = (this.user.primary_address && this.user.primary_address.id) || '';
            }
            else {
                this.profile.primary_address_id = 'new';
            }

            this.loaded = true;
        },
        showPageLoader() {
            this.pageLoader = true;
        },
        hidePageLoader() {
            this.pageLoader = false;
        },
        searchAddress() {
            this.showPageLoader();
            this.$refs.postcodeLookup.findAddress(this.postcodeSearch);
        },
        prefillAddress(property) {
            // Format town as it seems to come as all capitals
            let town = property.post_town;
            town = town.toLowerCase();
            town = town.charAt(0).toUpperCase() + town.substr(1);

            // Set our address field as the results of what was selected
            this.profile.address = property.line_1;
            this.profile.address2 = property.line_2;
            this.profile.postcode = property.postcode;
            this.profile.town = town;
            this.profile.county = property.county;
            this.profile.country = property.country;
        },
        processForm() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.updateProfile(this.profile)
                        .then(() => {
                            this.refreshUser();
                            this.$refs.modalProfileSaved.show();
                        })
                        .catch(({ response }) => {
                            this.$toasted.error(response.data.message);
                        });
                }
                else {
                    this.showErrors = true;
                    this.$toasted.error('Your profile update has errors. Please correct them and try again.');
                }
            });
        },
        showOrder(id) {
            this.visibleOrder = this.user.orders.data.find(order => order.id === id);
            this.$refs.modalOrder.show();
        },
        showViewing(id) {
            this.visibleViewing = this.viewings.data.find(order => order.id === id);
            this.$refs.modalViewing.show();
        },
        handleSubmitFeedback() {
            this.$validator.validate('field-feedback')
                .then((result) => {
                    if (result) {
                        this.updateViewing({
                            eventId: this.visibleViewing.id,
                            action: 'update',
                            feedback: this.viewingFeedback
                        })
                            .then(() => {
                                this.refreshUser()
                                    .then(() => {
                                        if (this.$refs.modalViewing.is_visible) {
                                            this.visibleViewing = this.viewings.data.find(viewing => viewing.id === this.visibleViewing.id);
                                        }
                                    });
                                this.$toasted.success('Thank you, your feedback has been received.');
                            })
                            .catch(() => {
                                this.$toasted.error('There was a problem while attempting to submit your feedback.');
                            });
                    }
                    else {
                        this.$toasted.error('Please include your viewing feedback.');
                    }
                });
        }
    }
};
</script>

<style lang="scss">
// credas logo
.credas-logo {
    width: 15rem;
    margin: 2rem 0 3rem 0;
}

// Listing with icons
.icon-list {
    display: flex;
    flex-wrap: wrap;

    li {
        margin-bottom: 1rem;
        flex: 0 1 100%;

        &:last-child {
            margin-bottom: 0;
        }
    }

    &--split {
        margin-left: -10px;
        margin-right: -10px;

        li {
            padding-left: 10px;
            padding-right: 10px;

            @include media-breakpoint-up(lg) {
                flex: 0 1 50%;
            }
        }
    }

    &__svg {
        margin-right: 2rem;
        color: theme-color('secondary');

        svg {
            width: 2rem;
        }
    }

    &--alert {
        .icon-list__svg {
            color: theme-color('primary');
        }
    }
}

// Custom styling for sidebar card
.alerts-card {
    margin: 0;

    @include media-breakpoint-down(md) {
        .table-flex > div > div:first-of-type {
            border-top: 1px solid theme-color('light-grey');
        }
    }
}

// property lookup
.modal {
    &#modal-propery-results {
        .modal-dialog {
            .modal-content {
                background: theme-color('light-grey');
            }

            .modal-header {
                background: theme-color('secondary');
            }
        }
    }
}

.property-lookup {
    max-height: 40vh;
    overflow-y: auto;
    background: white;
}

.property-item {
    cursor: pointer;
    padding: .5rem;
    border-bottom: 1px solid whitesmoke;
}

.sticky-save {
    position: fixed;
    bottom: 2rem;

    &__btn {
        display: block;
        background: theme-color('secondary');
        border-radius: global-var('rounded-corners');
        width: 9rem;
        height: 4rem;
        display: flex;
        align-items: center;
        padding: 1rem;
        color: white;
        font-weight: bold;
    }

    &__icon {
        color: white;
        width: 2rem;
        line-height: 0;
    }
}

</style>
